import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiFetch } from '../api/httpClient';

export default function AuthWatcher() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');

    // ✅ Si existe un token pero NO estás en /admin
    if (token && !location.pathname.startsWith('/admin')) {
      apiFetch('/auth/logout', { method: 'POST' })
        .finally(() => {
          localStorage.removeItem('token');
          localStorage.removeItem('usuario');

          // Redirige al login si está intentando acceder a una ruta restringida
          if (location.pathname === '/admin') {
            navigate('/login', { replace: true });
          }
        });
    }
  }, [location.pathname]);

  return null;
}
